import { putApi } from "./api_instance";

export const editRegistry = async ({ id, info }, logout) => {
  try {
    const data = await putApi({
      apiUrl: `/admin/projects/api/registry/${id}`,
      sendToken: true,
      data:  info ,
      logout,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
